import React from "react";
import moment from "moment-timezone";
import IntlMessages from "util/IntlMessages";
import { useGetUserCalendarEvents } from "../../../../../../hooks/api/project/useGetUserCalendarEvents";
import { useSelector } from "react-redux";
import { lighten } from "@material-ui/core/styles";
import { Tooltip } from "@material-ui/core";
import PopUpSkapaTidsrapport from "../../../../SkapaTidsrapport/PopUpSkapaTidsrapport";
import "moment/locale/sv"; 
import "moment/locale/en-gb"; 
import "moment/locale/nb"; 



const UpNext = () => {
	const Afid = useSelector(state => state.accountsData.currentAccount.id);
	const Userid = useSelector(state => state.auth.authUser.user_id);
	const authUser = useSelector(state => state.auth.authUser);
	const [plannedEvent, setPlannedEvent] = React.useState(null);
	//Jack localization
	const todayStartHour = moment()
	.minute(0)
	.second(0)
	.millisecond(0);
	const tomorrowStartHour = moment()
	.minute(0)
	.second(0)
	.millisecond(0)
	.add(1, "day")
	.hour(8);
	//End Jack localization
	const { data } = useGetUserCalendarEvents(
		Afid,
		Userid,
		[Userid],
		todayStartHour
			.clone()
			.hour(0)
			.toDate(),
		tomorrowStartHour
			.clone()
			.hours(23)
			.toDate()
	);
	//Jack localization
	const getmylocale =(lang)=>{
		switch(lang){
		  case "SE": return {
			languageId: 'Swedish',
			locale: 'sv',
			name: 'Svenska',
			icon: 'se'
		  }
		  case "NO": return  {
			languageId: 'Norwegian',
			locale: 'nb',
			name: 'Norska',
			icon: 'no'
		  }
		  case "US": return  {
			languageId: 'English',
			locale: 'en',
			name: 'engelska',
			icon: 'us'
		  }
		  default: return {
			languageId: 'Swedish',
			locale: 'sv',
			name: 'Svenska',
			icon: 'se'
		  }
		}
	  }
	  
	//End Jack localization
	const TimeDivider = ({ time }) => {
		return (
			<div className="d-flex align-items-center">
				<div
					style={{
						fontWeight: "bold",
						fontSize: 11,
						color: "#5b5b5b",
						position: "absolute"
					}}
				>
					{time.format("HH")}
				</div>
				<div
					style={{
						height: 1,
						flex: 1,
						backgroundColor: "rgb(232, 232, 232)",
						marginLeft: 17
					}}
				></div>
			</div>
		);
	};

	const CurrentTimeIndicator = () => {
		let diffInMinutes = moment().diff(todayStartHour, "minutes");
		let percent = ((diffInMinutes / 60) * 100) / 4;

		return (
			<div
				className="d-flex align-items-center"
				style={{
					zIndex: 1,
					position: "absolute",
					top: `${percent}%`,
					transform: "translateY(-50%)",
					width: "100%"
				}}
			>
				<div
					style={{
						height: 5,
						width: 5,
						borderRadius: "50%",
						background: "#5CD1D1",
						background:
							"linear-gradient(90deg,rgba(92, 209, 209, 1) 0%, rgba(33, 161, 167, 1) 100%)"
					}}
				></div>
				<div
					style={{
						height: 1,
						flex: 1,
						background: "#5CD1D1",
						background:
							"linear-gradient(90deg,rgba(92, 209, 209, 1) 0%, rgba(33, 161, 167, 1) 100%)"
					}}
				></div>
			</div>
		);
	};

	const EventItem = ({
		Start,
		End,
		diffDate,
		timeBlocks,
		color,
		ProjectName,
		ProjectNr,
		lane,
		lanesInGroup,
		eventObj,
		type,
		Beskrivning
	}) => {
		let diffInMinutesTop = moment(Start).diff(diffDate, "minutes");
		let percentTop = ((diffInMinutesTop / 60) * 100) / timeBlocks;

		if (percentTop < 0) percentTop = 0;

		let diffInMinutesHeight = moment(End).diff(diffDate, "minutes");
		let percentHeight = ((diffInMinutesHeight / 60) * 100) / timeBlocks;

		percentHeight = percentHeight - percentTop;

		const maxHeight = 100 - percentTop;
		if (percentHeight >= maxHeight) percentHeight = maxHeight;

		const lanes = lanesInGroup;
		const widthPercent = 100 / lanes;
		const left = widthPercent * lane;

		return (
			<Tooltip
				title={
					<>
						<p
							style={{
								fontSize: 12,
								color: "#fff",
								fontWeight: "bold",
								margin: 0
							}}
						>
							{type === "outlook" ? Beskrivning : ""}
							{ProjectName && `#${ProjectNr} ${ProjectName}`}
						</p>
						<p
							style={{
								fontSize: 12,
								color: "#fff",
								fontWeight: 500,
								margin: 0
							}}
						>
							{`${moment(Start).format("HH:mm")} - ${moment(End).format(
								"HH:mm"
							)}`}
						</p>
					</>
				}
			>
				<div
					onClick={() => setPlannedEvent(eventObj)}
					className="d-flex align-items-baseline"
					style={{
						position: "absolute",
						top: `calc(${percentTop}% + 1px)`,
						width: `${widthPercent}%`,
						right: `${left}%`,
						height: `calc(${percentHeight}% - 2px)`,
						backgroundColor: lighten(color, 0.8),
						borderRadius: 5,
						padding: 4,
						display: "flex",
						gap: 4,
						cursor: "pointer"
					}}
				>
					<div
						style={{ backgroundColor: color, alignSelf: "stretch", width: 2 }}
					></div>
					<div style={{ overflow: "hidden" }}>
						<p
							style={{
								fontSize: 10,
								color: color,
								fontWeight: "bold",
								margin: 0,
								whiteSpace: "nowrap",
								overflow: "hidden",
								textOverflow: "ellipsis"
							}}
						>
							{type === "outlook" ? Beskrivning : ""}
							{ProjectName && `#${ProjectNr} ${ProjectName}`}
						</p>
						<p
							style={{
								fontSize: 10,
								color: color,
								fontWeight: 500,
								margin: 0
							}}
						>
							{moment(Start).format("HH:mm")}
						</p>
					</div>
				</div>
			</Tooltip>
		);
	};

	const prepareData = events => {
		const sorted = [...events]
			.filter(
				e =>
					moment(e.Start).isBetween(
						todayStartHour,
						todayStartHour.clone().add(4, "days")
					) ||
					moment(e.End).isBetween(
						todayStartHour,
						todayStartHour.clone().add(4, "days")
					) ||
					moment(e.Start).isBetween(
						tomorrowStartHour,
						tomorrowStartHour.clone().add(9, "days")
					) ||
					moment(e.End).isBetween(
						tomorrowStartHour,
						tomorrowStartHour.clone().add(9, "days")
					)
			)
			.sort((a, b) => new Date(a.Start) - new Date(b.Start));
		const active = [];
		let groupId = 0;

		for (const event of sorted) {
			const Start = new Date(event.Start);

			// Clean up active list
			for (let i = active.length - 1; i >= 0; i--) {
				if (new Date(active[i].End) <= Start) {
					active.splice(i, 1);
				}
			}

			// Assign lane
			const usedLanes = active.map(e => e.lane);
			let lane = 0;
			while (usedLanes.includes(lane)) lane++;

			event.lane = lane;
			event.groupId = groupId;
			active.push(event);

			for (const e of active) {
				e.groupId = groupId;
			}

			const next = sorted[sorted.indexOf(event) + 1];
			if (next && new Date(next.Start) >= new Date(event.End)) {
				groupId++;
			}
		}

		// Determine how many lanes per group
		const laneCounts = {};
		for (const e of sorted) {
			laneCounts[e.groupId] = Math.max(laneCounts[e.groupId] || 0, e.lane + 1);
		}

		// Attach lane count info
		for (const e of sorted) {
			e.lanesInGroup = laneCounts[e.groupId];
		}

		return sorted;
	};
	//Jack localization
	const tomorrowStartHourreturn = ()=>{
		let locale=getmylocale(authUser.user_Lang)
		moment.locale(locale.locale)
		return moment(tomorrowStartHour).format("dddd, DD MMM")
	} 
	//
	return (
		<>
			<div className="d-flex h-100" style={{ padding: 18, gap: 8 }}>
				<div className="d-flex flex-column" style={{ flex: 1, gap: 8 }}>
					<div>
						<p
							style={{
								fontSize: 10,
								textTransform: "uppercase",
								fontWeight: 500,
								color: "#6a6a6a"
							}}
						>
							{moment().format("dddd")}
						</p>
						<h2
							style={{
								fontSize: 30,
								color:"rgba(92, 209, 209, 1)"
							}}
						>
							{moment().format("D")}
						</h2>
					</div>
					<div
						className="d-flex flex-column justify-content-between"
						style={{ flex: 1, position: "relative" }}
					>
						<CurrentTimeIndicator />
						<TimeDivider time={todayStartHour.clone()} />
						<TimeDivider time={todayStartHour.clone().add(1, "hour")} />
						<TimeDivider time={todayStartHour.clone().add(2, "hour")} />
						<TimeDivider time={todayStartHour.clone().add(3, "hour")} />
						<TimeDivider time={todayStartHour.clone().add(4, "hour")} />
						<div
							style={{
								height: "100%",
								width: "calc(100% - 14px)",
								position: "absolute",
								right: 0
							}}
						>
							{data?.UserCalendarList &&
								prepareData(
									data.UserCalendarList.filter(
										item =>
											moment(item.Start).isSame(todayStartHour, "day") ||
											moment(item.End).isSame(todayStartHour, "day")
									)
								).map((item, index) => (
									<EventItem
										key={index}
										{...item}
										eventObj={item}
										diffDate={todayStartHour}
										timeBlocks={4}
										color={"rgb(59, 175, 221)"}
									/>
								))}
						</div>
					</div>
				</div>
				<div className="d-flex flex-column" style={{ flex: 1 }}>
					<p
						style={{
							fontSize: 10,
							textTransform: "uppercase",
							fontWeight: 500,
							marginBottom: 15,
							marginLeft: 15,
							color: "#6a6a6a"
						}}
					>
						{tomorrowStartHourreturn()}
					</p>
					<div
						className="d-flex flex-column justify-content-between"
						style={{ flex: 1, position: "relative" }}
					>
						<TimeDivider time={tomorrowStartHour.clone()} />
						<TimeDivider time={tomorrowStartHour.clone().add(1, "hour")} />
						<TimeDivider time={tomorrowStartHour.clone().add(2, "hour")} />
						<TimeDivider time={tomorrowStartHour.clone().add(3, "hour")} />
						<TimeDivider time={tomorrowStartHour.clone().add(4, "hour")} />
						<TimeDivider time={tomorrowStartHour.clone().add(5, "hour")} />
						<TimeDivider time={tomorrowStartHour.clone().add(6, "hour")} />
						<TimeDivider time={tomorrowStartHour.clone().add(7, "hour")} />
						<TimeDivider time={tomorrowStartHour.clone().add(8, "hour")} />
						<TimeDivider time={tomorrowStartHour.clone().add(9, "hour")} />
						<div
							style={{
								height: "100%",
								width: "calc(100% - 14px)",
								position: "absolute",
								right: 0
							}}
						>
							{data?.UserCalendarList &&
								prepareData(
									data.UserCalendarList.filter(
										item =>
											moment(item.Start).isSame(tomorrowStartHour, "day") ||
											moment(item.End).isSame(tomorrowStartHour, "day")
									)
								).map((item, index) => (
									<EventItem
										key={index}
										{...item}
										eventObj={item}
										diffDate={tomorrowStartHour}
										timeBlocks={9}
										color={"rgb(59, 175, 221)"}
									/>
								))}
						</div>
					</div>
				</div>
			</div>
			<PopUpSkapaTidsrapport
				plannedEvent={plannedEvent}
				open={!!plannedEvent}
				handleClose={() => setPlannedEvent(null)}
			/>
		</>
	);
};
export default UpNext;
